import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/cn";

const contentBox = cva("flex w-full flex-1 items-center", {
  variants: {
    textAlign: {
      left: "",
      center: "text-center",
    },
  },
  defaultVariants: {
    textAlign: "left",
  },
});

interface LayoutProps extends React.PropsWithChildren {
  textAlign?: "left" | "center";
  columnSize?: string;
  className?: string;
}

function CenteredColumnLayout(props: LayoutProps) {
  const { textAlign = "left", columnSize = "392px", children, className } = props;

  return (
    <div
      className={cn("box-border flex min-h-full flex-col items-center gap-2.5 py-16", className)}
    >
      <div
        className={contentBox({ textAlign })}
        style={{
          maxWidth: columnSize,
        }}
      >
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
}

export { CenteredColumnLayout };
